var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page bg-gray"},[_c('div',{staticClass:"audience-group-editor-container"},[_c('GroupEditor',{attrs:{"id":_vm.id,"label":_vm.label}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }